<template>
  <div class="invoice-payment-details">
    <div v-if="hasInvoicePayments">
      <p>Payments made to this invoice:</p>
      <ItemPanelList class="mt-2">
        <ItemPanel v-for="payment of invoicePaymentList" :key="payment.id" :icon="iconClassForPaymentAllocationType(payment.type)">
          <template v-slot:title>
            <strong>
              <LinkPaymentReceived v-if="payment.type == InvoicePaymentAllocationTypes.payment" :id="payment.paymentReceived.id" name="Payment" />
              <LinkOverPayment v-if="payment.type == InvoicePaymentAllocationTypes.overpayment" :id="payment.overPayment.id" name="Over Payment" />
              <LinkCreditNote v-if="payment.type == InvoicePaymentAllocationTypes.creditNote" :id="payment.creditNote.id" name="Credit Note" />
            </strong>
          </template>
          <template v-slot:description>
            <span v-if="payment.type == InvoicePaymentAllocationTypes.payment">{{payment.paymentReceived.sequenceNumber}}</span>
            <span v-if="payment.type == InvoicePaymentAllocationTypes.overpayment">{{payment.overPayment.sequenceNumber}}</span>
            <span v-if="payment.type == InvoicePaymentAllocationTypes.creditNote">{{payment.creditNote.sequenceNumber}}</span>
          </template>
          <template v-slot:content>
            <ItemPanelData title="Status">
              <LabelBadge :labelClass="`label-payment-status-${payment.status}`">{{payment.status | formatLookupName(PaymentStatusTypeLookup)}}</LabelBadge>
            </ItemPanelData>
            <ItemPanelData title="Payment" v-if="payment.type == InvoicePaymentAllocationTypes.payment">
              <LabelBadge :labelClass="`label-payment-type-${payment.paymentReceived.paymentType}`">{{payment.paymentReceived.paymentType | formatLookupName(PaymentTypeLookup)}}</LabelBadge>
            </ItemPanelData>
            <ItemPanelData title="Date">
              {{payment.dateAllocated | formatDateTime}}
            </ItemPanelData>
            <ItemPanelData title="Amount">
              <strong>{{payment.allocatedAmount | formatCurrency}}</strong>
            </ItemPanelData>
          </template>
        </ItemPanel>
      </ItemPanelList>
    </div>
  </div>
</template>

<style scoped>
.invoice-payment-details {
  font-size: 0.75rem;
}
</style>

<script>
import FormMixin from '@/mixins/form'
import { PaymentStatusTypes, PaymentStatusTypeLookup, PaymentTypes, PaymentTypeLookup, InvoicePaymentAllocationTypes, InvoicePaymentAllocationTypeLookup } from '@/store/types'

export default {
  name: 'InvoicePaymentList',
  mixins: [FormMixin],
  props: {
    invoicePaymentList: Array
  },
  computed: {
    hasInvoicePayments() {
      return this.invoicePaymentList && this.invoicePaymentList.length > 0
    }
  },
  created() {
    this.PaymentStatusTypeLookup = PaymentStatusTypeLookup
    this.PaymentTypeLookup = PaymentTypeLookup
    this.InvoicePaymentAllocationTypes = InvoicePaymentAllocationTypes
    this.InvoicePaymentAllocationTypeLookup = InvoicePaymentAllocationTypeLookup
  },
  methods: {
    iconClassForPaymentAllocationType(allocationType) {
      if(allocationType == InvoicePaymentAllocationTypes.payment)
        return 'fa-usd-circle'
      if(allocationType == InvoicePaymentAllocationTypes.creditNote)
        return 'fa-money-check-alt'
      if(allocationType == InvoicePaymentAllocationTypes.overpayment)
        return 'fa-sack-dollar'
    }
  }
}
</script>